import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  entity_name: {
    name: 'Prime Broker Name'
  },
  entity_identification_lei: {
    name: 'Prime Broker LEI Code'
  },
  entity_identification_bic: {
    name: 'Prime Broker BIC Code'
  }
};

export function PrimeBrokerFund({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.PRIME_BROKE_FUNDS,
    onChangeFund,
    schema: schema.PRIME_BROKE_FUNDS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.PRIME_BROKE_FUNDS?.field_names || [],
    columnLables,
    tableName: 'PRIME_BROKE_FUNDS',
    order: 45,
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id="reporttables-prime-broker-fund-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
